<template>
  <NuxtLink
    to="#main-content"
    class="visually-hidden"
    :aria-label="$t('scrollToMainContent')"
  >
    {{ $t("scrollToMainContent") }}
  </NuxtLink>
  <CommonAppHeader />
  <main
    id="main-content"
    class="mx-auto flex w-full max-w-[2560px] flex-auto flex-col"
  >
    <slot />
  </main>
  <CommonFooterCertificates />
  <CommonAppFooter v-if="!isCheckout" />
  <DialogsMarketingPopup />
  <CommonAppOverlay />
  <UiSystemLoader />
</template>

<script lang="ts" setup>
const route = useRoute();
const isCheckout = computed(() => {
  return (
    route.path.includes("checkout") && !route.path.includes("checkout/success")
  );
});
</script>
